import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company_id = data?.company
        }
        if (data?.customer) {
            datas.customer_id = data?.customer
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data.id) {
            datas.id = data.id
        }
    }
    return ApiService.get('/api/v1/shopify_integration/stores/', datas)
}
// This function is no longer used - replaced by oneClickAuthorize

export const oneClickAuthorize = data => ApiService.post(`/api/v1/shopify_integration/oauth/one-click-authorize/`, data)

export const customAppAuthorize = data => ApiService.post(`/api/v1/shopify_integration/oauth/custom-app-authorize/`, data)
export const getApiRecord = id => ApiService.get(`/api/v1/shopify_integration/stores/${id}/`)
export const updateApiRecord = (id, data) => ApiService.patch(`/api/v1/shopify_integration/stores/${id}/`, data)
// Consolidated with updateApiRecord since they perform the same operation
export const deleteApiRecord = id => ApiService.delete(`/api/v1/shopify_integration/stores/${id}/`)
export const callbackApi = (code, shop, state) => {
    // Normalize shop domain - ensure it has .myshopify.com but not duplicated
    let normalizedShop = shop
    if (!normalizedShop.includes('.myshopify.com')) {
        normalizedShop += '.myshopify.com'
    }

    return ApiService.get(`/api/v1/shopify_integration/callback?code=${code}&shop=${normalizedShop}&state=${state}`)
}

export const syncAllShopifyTasks = () => ApiService.post('/api/v1/shopify_integration/sync-all-tasks/')
